<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="dialog"
      hide-overlay
      transition="dialog-bottom-transition"
      lazy
      persistent
      max-width="600px"
    >
      <v-card>
        <v-toolbar dark color="blue">
          <v-toolbar-title>Cadastro de URL Encurtada</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark flat @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container fluid>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card flat>
              <v-card-text>
                <v-container grid-list-md fluid>
                  <v-layout wrap>
                    <v-flex xs8 sm8 md8>
                      <v-text-field
                        label="Código Encurtado"
                        v-model="urlCode"
                        :rules="codeRules"
                        required
                        :disabled="type === 'edit'"
                        @change="validateDuplicate($event)"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4 sm4 md4>
                      <v-btn dark small @click="createCode()">Gerar</v-btn>
                    </v-flex>
                    <v-flex xs12>
                      <!-- <v-text-field                       
                        label="Url Encurtada"
                        hint="Url completa, nao esqueça dos UTMs" 
                        :value="'https://juntos.eco/' + ( urlCode ? urlCode : '' )"
                        disabled
                      ></v-text-field> -->
                      <v-autocomplete
                        :items="domains"
                        label="dominio"
                        v-model="baseUrl"
                        :suffix="urlCode"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        label="Url Longa"
                        hint="Url completa, nao esqueça dos UTMs"
                        v-model="longUrl"
                        :rules="[
                          (v) => !!v || 'Por favor, informe a URL Completa',
                        ]"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="error" @click="dialog = false">
                  Fechar
                </v-btn>
                <v-btn
                  flat
                  color="success"
                  @click="validate()"
                  :loading="loading"
                  :disabled="buttonDisable()"
                >
                  Salvar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-container>
      </v-card>
      <v-snackbar v-model="snackbar" :color="snackbar_color" :timeout="6000">
        {{ snackbar_msg }}
      </v-snackbar>
    </v-dialog>
  </v-layout>
</template>

<script>
import { eventBus } from "@/main";
import { mapActions, mapState } from "vuex";
import {
  createUrlCode,
  getUrlShortner,
  createUrlShortner,
} from "../../services/shortner";

export default {
  components: {},
  data: () => ({
    valid: false,
    rules: [],
    codeRules: [],
    dialog: false,
    type: "new",
    urlCode: null,
    shortUrl: null,
    longUrl: null,
    snackbar: false,
    snackbar_color: "green",
    snackbar_msg: "",
    baseUrl: "https://juntos.eco/",
    domains: [
      "https://juntos.eco/",
      "https://eletron.eco/",
      "https://mercadoliv.re/",
      "https://eletron.energy/",
    ],
  }),
  computed: {
    ...mapState("configuration", ["loading"]),
  },
  mounted() {
    eventBus.$on("UrlShortnerForm", (obj) => {
      if (obj.type === "edit") {
        this.urlCode = obj.data.urlCode;
        this.shortUrl = obj.data.shortUrl;
        this.longUrl = obj.data.longUrl;
      } else if (obj.type === "new") {
        this.urlCode = null;
        this.shortUrl = null;
        this.longUrl = null;
      }
      this.type = obj.type;
      this.dialog = obj.status;
    });
  },
  watch: {
    urlCode() {
      this.codeRules = [];
    },
  },
  methods: {
    ...mapActions("configuration", ["addUrlShortner", "updateUrlShortner"]),

    buttonDisable() {
      return !this.valid || this.name === "";
    },
    async createCode() {
      let urlCode = await createUrlCode();
      this.urlCode = urlCode;
    },
    async validateDuplicate(urlCode) {
      let urlS = null;
      urlS = await getUrlShortner(urlCode);
      if (urlS && urlS.exists) {
        this.codeRules = [
          (v) => !!v || "Por favor, informe o código encurtado!",
          () => (urlS && !urlS.exists) || "Já existe esse código encurtado",
        ];
      }
    },
    async validate() {
      let urlS = null;
      urlS = await getUrlShortner(this.urlCode);
      if (urlS && urlS.exists) {
        this.codeRules = [
          (v) => !!v || "Por favor, informe o código encurtado!",
          () => (urlS && !urlS.exists) || "Já existe esse código encurtado",
        ];
        this.valid = false;
      }
      if (this.$refs.form.validate()) {
        this.valid = true;
        let res = await createUrlShortner(
          this.type,
          this.urlCode,
          this.longUrl,
          this.baseUrl,
        );
        if (res && res.error === "") {
          this.snack("Url longa é invalida", "red");
        } else if (res && res.error === "invalidURLCode")
          this.snack("Informe um código para a URL encurtada!", "red");
        else if (res && res.error)
          this.snack("Erro ao criar a Url encurtada! " + res.error, "red");
        else this.snack("Url encurtada criada com sucesso! ", "green");
      }
      // this.dialog = false
    },
    snack(msg, color) {
      this.snackbar_color = color;
      this.snackbar_msg = msg;
      this.snackbar = true;
    },
  },
};
</script>
